<template>
  <picture class="image-component">
    <source :srcset="desktopPath" :media="`(min-width: ${desktopQuerie})`">
    <source v-if="tabletPath" :srcset="tabletPath"
      :media="`(min-width: ${mobileQuerie}) and (max-width: ${desktopQuerie})`">
    <source :srcset="mobilePath" :media="`(max-width: ${mobileQuerie})`">
    <img v-once :alt="altText" loading="lazy" :src="mobilePath" />
  </picture>
</template>

<script setup lang="ts">
defineProps<{
  mobilePath: string,
  tabletPath?: string | false,
  desktopPath: string,
  mobileQuerie: string,
  desktopQuerie: string,
  altText: string,
}>()
</script>
